/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FilterSelectionsDTO } from './filterSelectionsDTO';


export interface UpdateMIMFiltersRequestDTO { 
    /**
     * Measured client identifier. Use the client ID returned by the authenticated context.
     */
    clientId: number;
    /**
     * Brand identifier within the client. Use this together with clientId when a request targets a specific brand.
     */
    brandId: number;
    /**
     * Conversion event type the filters apply to
     */
    conversionType: string;
    /**
     * Metric view type controlling whether the page shows ROAS or CPO metrics
     */
    viewBy: UpdateMIMFiltersRequestDTO.ViewByEnum;
    /**
     * Relative day label for the analysis period (e.g. \'latest30\', \'latest90\')
     */
    relativeDay?: string;
    /**
     * Analysis period start date in ISO-8601 format
     */
    startDate?: string;
    /**
     * Analysis period end date in ISO-8601 format
     */
    endDate?: string;
    selections?: FilterSelectionsDTO;
}
export namespace UpdateMIMFiltersRequestDTO {
    export type ViewByEnum = 'ROAS' | 'CPO';
    export const ViewByEnum = {
        Roas: 'ROAS' as ViewByEnum,
        Cpo: 'CPO' as ViewByEnum
    };
}


